import { storeConversation, setConversation } from '../Reducers/twilio';

export default function twilioSetConversation(conversation) {
  return (dispatch, getState) => {
    const user = getState().twilio.user;
    const newConversation = storeConversation(conversation, user);
    dispatch(setConversation(newConversation));
  };
}
